import { render } from "./TeamsTable.vue?vue&type=template&id=5381a073&scoped=true"
import script from "./TeamsTable.vue?vue&type=script&lang=js"
export * from "./TeamsTable.vue?vue&type=script&lang=js"

import "./TeamsTable.vue?vue&type=style&index=0&id=5381a073&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5381a073"]])

export default __exports__